// project imports
// (gerado/actualizado por scripts/generate-logo-components.mjs a partir de assets)
import { SvgIcon, SvgIconProps } from '@mui/material';

// ==============================|| LogoHorizontalAlternative ||============================== //

const LOGO_VIEW_BOX = "0.00 0.00 1598.00 727.00";

export default function LogoHorizontalAlternative(props: SvgIconProps) {
  const { titleAccess = "Swift Soft", sx, ...other } = props;
  return (
    <SvgIcon
      viewBox={LOGO_VIEW_BOX}
      titleAccess={titleAccess}
      role="img"
      {...other}
      sx={{ color: 'inherit', ...sx }}
    >
      <path key={0} fill="currentColor" d="
  M 128.03 129.02
  A 0.64 0.63 -65.0 0 0 127.85 128.51
  L 89.08 89.50
  A 2.93 2.92 -75.7 0 1 88.34 88.25
  Q 88.02 87.17 88.02 84.50
  Q 87.96 59.54 88.04 9.81
  Q 88.05 5.52 92.16 5.19
  C 99.22 4.64 110.59 4.22 116.35 8.40
  C 120.57 11.46 124.92 16.19 128.30 19.64
  Q 134.30 25.78 235.16 126.60
  Q 236.38 127.82 237.09 129.22
  A 1.11 1.09 -43.7 0 1 237.06 130.27
  Q 235.38 133.13 234.13 134.38
  Q 42.86 325.65 40.90 327.65
  C 36.51 332.12 31.26 335.82 24.41 335.93
  Q 16.04 336.07 8.15 335.98
  A 2.17 2.17 0.0 0 1 6.01 333.81
  Q 5.97 296.59 6.03 254.02
  Q 6.04 251.32 8.68 248.67
  Q 68.88 188.41 95.02 162.39
  Q 95.04 162.37 99.56 158.23
  Q 102.75 155.30 105.43 152.18
  Q 109.04 147.94 116.48 141.41
  C 119.97 138.33 123.80 133.23 127.66 129.91
  Q 127.98 129.63 128.03 129.02
  Z"
/>
      <path key={1} fill="currentColor" d="
  M 483.64 7.01
  Q 483.99 9.13 484.01 10.25
  Q 484.32 35.96 483.94 57.85
  A 2.38 2.38 0.0 0 1 482.75 59.86
  C 480.05 61.40 474.94 61.00 469.27 61.00
  Q 256.77 60.97 239.00 61.04
  Q 228.23 61.08 218.70 62.44
  Q 215.10 62.95 207.66 65.61
  A 2.01 1.98 -50.7 0 1 206.74 65.71
  Q 205.19 65.49 203.91 64.32
  Q 202.52 63.06 200.22 60.78
  Q 178.19 39.03 168.56 28.69
  Q 167.10 27.11 166.61 26.63
  A 1.40 1.40 0.0 0 1 166.77 24.50
  C 170.35 21.89 174.80 20.08 179.64 17.83
  Q 199.87 8.40 222.26 6.52
  Q 228.91 5.96 233.43 5.58
  Q 240.21 5.00 244.60 5.00
  Q 359.65 5.00 474.25 5.01
  Q 479.01 5.01 483.04 6.30
  A 0.88 0.88 0.0 0 1 483.64 7.01
  Z"
/>
      <path key={2} fill="currentColor" d="
  M 851.33 299.81
  A 0.26 0.26 0.0 0 0 851.83 299.81
  L 929.73 6.18
  A 1.52 1.52 0.0 0 1 931.20 5.05
  L 977.34 5.05
  A 1.53 1.53 0.0 0 1 978.86 6.42
  Q 979.18 9.73 978.50 12.24
  Q 947.33 125.79 892.26 327.99
  Q 891.81 329.64 890.75 331.66
  A 2.59 2.58 -76.0 0 1 888.47 333.03
  Q 856.04 332.96 826.30 333.10
  Q 823.29 333.12 820.00 332.79
  Q 817.98 332.59 817.44 330.57
  Q 746.36 65.53 742.88 52.56
  A 0.19 0.19 0.0 0 0 742.52 52.52
  Q 741.66 54.13 741.28 55.53
  Q 682.48 271.34 666.96 327.76
  Q 666.44 329.64 665.82 331.54
  A 2.17 2.17 0.0 0 1 663.76 333.03
  L 594.38 333.03
  A 1.71 1.71 0.0 0 1 592.83 332.04
  Q 592.49 331.31 591.90 329.18
  Q 583.95 300.36 506.61 11.43
  Q 505.98 9.05 506.16 6.47
  A 1.53 1.52 -87.8 0 1 507.68 5.06
  L 555.15 5.06
  A 1.64 1.64 0.0 0 1 556.74 6.29
  L 632.97 299.77
  A 0.25 0.25 0.0 0 0 633.45 299.77
  L 711.27 6.46
  A 1.82 1.82 0.0 0 1 713.02 5.10
  Q 740.77 4.86 771.17 5.13
  C 773.20 5.15 774.51 4.82 775.25 7.27
  Q 776.09 10.07 777.91 17.07
  Q 836.82 243.63 851.33 299.81
  Z"
/>
      <rect key={3} fill="currentColor" x="1004.00" y="5.04" width="48.00" height="327.96" rx="2.16"/>
      <path key={4} fill="currentColor" d="
  M 1124.00 150.32
  A 0.70 0.70 0.0 0 0 1124.70 151.02
  L 1282.35 151.02
  A 1.65 1.65 0.0 0 1 1284.00 152.67
  L 1284.00 193.98
  A 2.02 2.02 0.0 0 1 1281.98 196.00
  L 1125.97 196.00
  A 1.97 1.96 -0.1 0 0 1124.00 197.97
  Q 1124.01 212.16 1123.99 330.99
  Q 1123.99 332.96 1121.49 332.96
  Q 1101.50 333.01 1079.24 333.03
  Q 1077.06 333.03 1076.10 331.65
  A 0.54 0.53 27.7 0 1 1076.00 331.34
  L 1076.00 6.83
  A 1.82 1.82 0.0 0 1 1077.82 5.01
  L 1295.86 5.00
  A 2.08 2.08 0.0 0 1 1297.94 7.07
  Q 1298.13 27.88 1297.91 45.91
  Q 1297.86 50.00 1293.50 50.00
  Q 1149.55 49.98 1124.30 50.02
  A 0.31 0.31 0.0 0 0 1124.00 50.33
  L 1124.00 150.32
  Z"
/>
      <path key={5} fill="currentColor" d="
  M 1457.99 5.00
  Q 1569.76 4.99 1580.50 5.02
  Q 1588.89 5.04 1592.34 5.14
  A 1.14 1.14 0.0 0 1 1593.39 5.92
  Q 1593.92 7.59 1593.94 9.76
  Q 1594.14 42.61 1593.82 46.25
  Q 1593.49 49.91 1589.52 49.93
  Q 1570.11 50.04 1482.59 49.98
  A 0.60 0.60 0.0 0 0 1481.99 50.58
  L 1481.99 330.91
  A 2.04 2.04 0.0 0 1 1480.00 332.95
  Q 1477.92 333.00 1458.00 333.00
  Q 1438.09 333.00 1436.01 332.95
  A 2.04 2.04 0.0 0 1 1434.02 330.91
  L 1433.99 50.58
  A 0.60 0.60 0.0 0 0 1433.39 49.98
  Q 1345.87 50.05 1326.46 49.94
  Q 1322.49 49.92 1322.16 46.26
  Q 1321.84 42.62 1322.03 9.77
  Q 1322.05 7.60 1322.58 5.93
  A 1.14 1.14 0.0 0 1 1323.63 5.15
  Q 1327.08 5.05 1335.47 5.03
  Q 1346.22 5.00 1457.99 5.00
  Z"
/>
      <path key={6} fill="currentColor" d="
  M 206.09 193.82
  Q 207.10 192.34 209.48 189.98
  Q 215.36 184.14 254.52 144.82
  Q 256.19 143.15 259.51 143.09
  C 277.47 142.79 294.09 142.02 314.83 141.99
  Q 362.39 141.92 373.00 142.13
  Q 396.41 142.60 411.21 145.77
  Q 421.42 147.96 433.86 153.00
  C 451.72 160.23 466.45 171.86 477.17 187.46
  Q 478.98 190.09 480.18 192.57
  C 481.29 194.85 483.05 197.55 483.90 199.58
  C 490.30 214.91 492.40 229.42 491.48 245.78
  Q 490.78 258.18 486.77 269.94
  Q 475.72 302.32 444.71 319.18
  Q 438.07 322.79 425.56 327.54
  Q 419.13 329.99 399.76 333.55
  Q 395.08 334.41 380.78 334.74
  Q 369.63 335.00 361.72 335.00
  Q 136.37 334.99 80.00 335.00
  C 75.88 335.00 70.15 335.38 68.27 332.80
  A 2.29 2.12 -40.9 0 1 68.58 329.96
  Q 104.03 294.31 115.95 282.45
  Q 117.85 280.56 119.71 279.59
  Q 120.86 278.99 124.35 278.99
  Q 296.24 279.02 386.25 278.98
  Q 401.84 278.98 415.38 272.64
  Q 425.40 267.95 431.70 258.24
  Q 434.73 253.57 435.56 247.54
  Q 437.22 235.55 434.38 224.36
  A 5.80 5.39 25.6 0 0 433.88 223.09
  Q 429.79 215.66 427.19 213.08
  C 414.15 200.10 395.70 198.00 378.00 198.00
  Q 236.19 197.97 215.00 198.02
  C 211.38 198.03 208.41 197.63 206.12 194.71
  A 0.76 0.75 -47.3 0 1 206.09 193.82
  Z"
/>
      <path key={7} fill="currentColor" d="
  M 980.66 505.85
  C 980.08 503.07 980.17 499.77 979.52 496.45
  C 972.30 459.19 935.96 444.63 901.54 444.12
  C 884.78 443.88 868.72 446.52 854.09 452.64
  C 840.55 458.31 827.32 469.04 821.59 482.21
  C 816.80 493.21 815.98 508.69 822.21 519.56
  C 827.43 528.67 837.79 534.95 847.73 538.55
  C 861.06 543.38 875.68 545.99 889.27 548.21
  Q 916.55 552.65 935.34 555.94
  C 950.46 558.58 965.91 562.28 980.30 568.71
  Q 987.72 572.02 996.23 578.08
  C 1019.91 594.94 1025.47 622.87 1021.44 649.94
  Q 1018.94 666.72 1010.79 679.36
  Q 1001.38 693.97 986.45 703.70
  C 958.08 722.20 922.92 725.24 890.00 723.82
  C 863.06 722.66 837.15 715.76 815.15 700.09
  C 797.66 687.64 785.85 667.81 782.60 646.46
  Q 781.83 641.37 781.18 632.99
  Q 780.89 629.29 784.74 629.14
  Q 793.94 628.77 805.57 629.11
  C 807.66 629.17 809.53 628.98 811.25 629.55
  A 2.20 2.20 0.0 0 1 812.75 631.58
  Q 813.51 658.13 833.93 674.83
  Q 845.29 684.12 858.69 688.28
  C 865.73 690.47 871.79 692.20 878.98 693.25
  Q 904.27 696.94 929.24 693.00
  C 951.65 689.47 978.43 677.95 987.23 654.98
  C 992.57 641.05 993.09 624.00 985.07 611.20
  C 978.81 601.21 968.63 595.31 957.61 591.66
  Q 944.13 587.19 928.53 584.57
  Q 872.43 575.13 871.85 575.03
  C 852.31 571.58 834.03 567.19 817.22 557.35
  C 801.99 548.42 791.23 534.78 787.99 518.04
  Q 785.57 505.51 787.14 491.08
  C 791.21 453.45 821.83 429.39 856.27 420.29
  C 878.84 414.33 903.20 413.46 925.43 416.67
  C 956.38 421.14 986.12 436.01 1001.63 464.43
  Q 1010.84 481.32 1011.68 502.10
  C 1011.74 503.62 1012.48 505.61 1011.09 506.75
  A 1.04 1.03 25.5 0 1 1010.45 506.97
  L 982.05 506.97
  A 1.42 1.42 0.0 0 1 980.66 505.85
  Z"
/>
      <path key={8} fill="currentColor" d="
  M 1351.49 723.99
  L 1322.57 723.99
  A 0.81 0.80 80.3 0 1 1321.81 723.45
  Q 1320.99 721.17 1320.99 717.50
  Q 1321.03 571.86 1320.99 522.67
  A 0.68 0.67 90.0 0 0 1320.32 521.99
  Q 1305.38 522.03 1288.25 521.95
  Q 1284.08 521.94 1284.03 517.77
  Q 1283.85 503.52 1284.24 497.77
  Q 1284.41 495.15 1287.48 495.11
  Q 1301.42 494.93 1320.22 495.01
  A 0.70 0.70 0.0 0 0 1320.92 494.33
  Q 1321.11 484.96 1322.02 471.51
  Q 1322.61 462.79 1325.21 453.65
  C 1332.00 429.77 1350.98 418.53 1374.69 415.96
  Q 1402.38 412.96 1430.77 418.42
  A 1.56 1.56 0.0 0 1 1432.03 419.95
  L 1432.03 444.23
  A 0.79 0.79 0.0 0 1 1431.23 445.02
  Q 1426.84 444.96 1415.13 443.32
  Q 1409.05 442.47 1401.75 442.24
  C 1392.62 441.95 1381.83 442.20 1372.66 444.91
  C 1357.90 449.26 1352.72 460.84 1351.40 475.12
  Q 1350.49 484.89 1351.07 494.14
  A 0.90 0.90 0.0 0 0 1351.97 494.99
  Q 1424.39 495.00 1428.75 495.00
  Q 1430.72 494.99 1431.60 495.85
  A 1.23 1.22 -68.1 0 1 1431.97 496.73
  Q 1432.03 505.97 1432.01 519.04
  C 1432.00 521.52 1431.13 522.00 1428.67 522.00
  Q 1399.73 522.00 1352.31 522.00
  A 0.31 0.31 0.0 0 0 1352.00 522.31
  L 1352.00 723.48
  A 0.51 0.51 0.0 0 1 1351.49 723.99
  Z"
/>
      <path key={9} fill="currentColor" d="
  M 1484.75 515.01
  L 1513.91 515.01
  A 1.15 1.14 -0.0 0 0 1515.06 513.87
  L 1515.06 490.51
  A 1.53 1.53 0.0 0 0 1513.53 488.98
  L 1484.67 488.98
  A 0.64 0.64 0.0 0 1 1484.03 488.34
  L 1484.03 416.54
  A 1.50 1.49 -0.0 0 1 1485.53 415.05
  L 1513.51 415.05
  A 1.43 1.43 0.0 0 1 1514.94 416.48
  L 1514.94 487.84
  A 0.99 0.98 -82.3 0 0 1515.66 488.79
  Q 1516.94 489.15 1519.37 489.12
  Q 1540.77 488.88 1589.73 489.07
  Q 1592.00 489.08 1593.27 490.32
  A 1.41 1.38 -70.9 0 1 1593.67 491.17
  Q 1594.61 500.84 1593.78 511.49
  Q 1593.67 512.91 1593.25 514.10
  A 1.32 1.31 -80.3 0 1 1592.01 514.98
  L 1516.12 514.98
  A 0.98 0.97 -87.1 0 0 1515.15 515.86
  Q 1514.96 517.98 1514.96 518.75
  Q 1515.03 616.09 1514.99 641.75
  C 1514.97 659.60 1516.43 683.63 1535.27 692.27
  C 1539.95 694.42 1543.89 695.57 1549.06 695.92
  C 1562.38 696.82 1575.51 694.26 1589.09 691.06
  Q 1591.02 690.60 1592.73 691.28
  A 1.01 0.99 -86.2 0 1 1593.34 691.99
  Q 1593.87 694.29 1593.98 696.50
  Q 1594.44 705.91 1593.84 714.79
  C 1593.68 717.22 1591.71 717.61 1589.30 718.22
  C 1569.83 723.16 1552.22 726.01 1533.40 722.70
  C 1520.17 720.38 1507.99 713.22 1499.78 702.99
  C 1486.13 686.01 1483.95 663.62 1483.97 642.26
  Q 1484.06 568.17 1483.97 515.79
  A 0.78 0.78 0.0 0 1 1484.75 515.01
  Z"
/>
      <path key={10} fill="currentColor" d="
  M 1158.26 482.90
  Q 1168.71 482.90 1176.48 484.09
  Q 1225.39 491.62 1250.38 533.69
  C 1262.55 554.19 1267.58 579.35 1267.60 603.44
  C 1267.63 627.54 1262.65 652.71 1250.51 673.22
  Q 1225.60 715.34 1176.70 722.96
  Q 1168.93 724.18 1158.48 724.19
  Q 1148.04 724.20 1140.26 723.00
  Q 1091.35 715.47 1066.36 673.40
  C 1054.19 652.90 1049.16 627.74 1049.14 603.65
  C 1049.12 579.55 1054.10 554.38 1066.23 533.87
  Q 1091.14 491.75 1140.04 484.13
  Q 1147.81 482.91 1158.26 482.90
  Z
  M 1080.20 603.53
  C 1080.19 619.65 1082.94 635.78 1088.97 650.31
  C 1100.99 679.32 1126.83 696.04 1158.36 696.04
  C 1189.90 696.05 1215.74 679.35 1227.78 650.34
  C 1233.80 635.81 1236.56 619.68 1236.56 603.56
  C 1236.57 587.44 1233.82 571.31 1227.79 556.78
  C 1215.77 527.77 1189.93 511.05 1158.40 511.05
  C 1126.86 511.04 1101.02 527.74 1088.98 556.75
  C 1082.96 571.28 1080.20 587.41 1080.20 603.53
  Z"
/>
    </SvgIcon>
  );
}
